import React, { useEffect, useState } from "react";
import { PageContent, CustomBreadcrumb } from "components/Common";
import CombineStatMonthlyResultInstrument from './CombineStatMonthlyResultInstrument'
import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import SiteService from "services/Site";

const RESOURCE = ModuleIds.CombineStatMonthlyResultInstrument;

const CombineStatMonthlyResultInstrumentContainer = ({ t }) => {
  const [sites, setSites] = useState([]);
  const getData = async () => {
    const res = await SiteService.getListMasterSite({
      page: 1,
      size: 1000,
      search: "",
    });
    let result = res.map(
      item =>
        (item = {
          value: item.siteCode,
          label: item.siteName,
        })
    );
    setSites(result);
  };
  useEffect(() => {
    getData();
  }, []);

  const titleTag = `Danh sách xét nghiệm máy`;
  return (
    <PageContent title={t(titleTag)}>
      {/* Page Title */}
      <CustomBreadcrumb
        breadcrumbItem={titleTag}
        resource={RESOURCE}
        icon={<i className="mdi mdi-clipboard-list"></i>}
      />
      {/* Page Body */}
    <CombineStatMonthlyResultInstrument sites={sites}/>
    </PageContent>
  );
};

CombineStatMonthlyResultInstrumentContainer.propTypes = {
  t: PropTypes.any,
};

export default withTranslation(["combineStatMonthlyResultInstrumentPage"])(CombineStatMonthlyResultInstrumentContainer);
